import utils from './utils';

export default (function () {
    const reducers = {
        updateObject: function (oldObject, newValues) {

            /**
             * Encapsulate the idea of passing a new object as the first parameter
             * to Object.assign to ensure we correctly copy data instead of mutating.
             */
            return Object.assign({}, oldObject, newValues);
        },

        /**
         * Remove a specific key from an object.
         *
         * @param {Object} obj
         * @param {string} key
         * @returns {Object}
         */
        removeItemFromObject: function (obj, key) {
            // Create a copy.
            const newObject = obj;

            // Validate if it exists.
            if (newObject[key]) {
                // Delete the new value.
                delete newObject[key];
            }

            // Return a new state.
            return reducers.updateObject(obj, newObject);
        },

        /**
         * Remove all occurrences of value from an array.
         *
         * @param {Array} arr
         * @param {string} value
         * @returns {Array}
         */
        removeItemFromArrayOfStrings: function (arr, value) {
            const newArray = [];

            utils.each(arr, function (arrValue) {
                if (arrValue !== value) {
                    newArray.push(arrValue);
                }
            });

            return newArray;
        },

        /**
         * Get a list of available filter categories.
         *
         * @returns {Array}
         */
        getFilterCategories: function () {
            return [
                reducers.FILTER_BASIC,
                reducers.FILTER_ADVANCED,
            ];
        },

        /**
         * Filter out all the unknown state params and cast values when possible.
         *
         * @param {Object} intitialState
         * @param {Object} newState
         */
        normaliseState: function (intitialState, newState) {
            let normalisedList = utils.only(newState, Object.keys(intitialState));

            utils.each(normalisedList, (value, key) => {
                // This function will check if the value can be converted to a integer.
                normalisedList[key] = isNaN(value) ? value : parseInt(value, 10);
            });

            return normalisedList;
        },

        /**
         * This function will transform from an array of results to an Object.
         *
         * @param {Array} arr
         *
         * @returns {Object}
         */
        formatLocalisations: function (arr) {
            return arr.reduce((obj, item) => {
                // Does the language keys exist?
                obj[item.language] = obj[item.language] || {};

                // Set the new value in the language key.
                obj[item.language] = Object.assign(obj[item.language], {
                    [item.key]: item.value,
                });

                return obj;
            }, {});
        },
    };

    reducers.FILTER_BASIC = 'basic';
    reducers.FILTER_ADVANCED = 'advanced';

    return reducers;
})();



// WEBPACK FOOTER //
// ./src/helpers/reducers.js